import { useState, useMemo } from "react";

export function useCarousel(totalSlides: number) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => setCurrentSlide(currentSlide + 1);
  const prevSlide = () => setCurrentSlide(currentSlide - 1);
  const hasNext = useMemo(() => currentSlide < totalSlides - 1, [currentSlide]);
  const hasPrev = useMemo(() => currentSlide > 0, [currentSlide]);

  return {
    models: {
      currentSlide,
      hasNext,
      hasPrev,
      totalSlides,
    },
    operations: {
      setCurrentSlide,
      nextSlide,
      prevSlide,
    },
  };
}
